
import { Component, Vue } from 'vue-property-decorator'
import { WPXFormValue } from '@/components/templates/WPXForm';
import { CreateShiftAutomationForm } from '@/services/Calendar/ShiftAutomation/forms/CreateShiftAutomationForm';
import ShiftAutomationRepository from '@/services/Calendar/ShiftAutomation';
import { ShiftTypeInterface } from '@/services/Calendar/ShiftType/Interfaces';
import { UserInterface } from '@/services/Users/Interfaces';
import ShiftTypeRepository from '@/services/Calendar/ShiftType';
import UsersRepo from '@/services/Users';

@Component({
  inject: [
    'shiftAutomationRepository',
    'shiftTypeRepository',
    'userRepository',
  ],
})
export default class CreateShiftType extends Vue {
  private readonly shiftAutomationRepository!: ShiftAutomationRepository;
  private readonly shiftTypeRepository!: ShiftTypeRepository;
  private readonly userRepository!: UsersRepo;

  private loading: boolean = true;

  private shiftType: ShiftTypeInterface[] = [];
  private users: UserInterface[] = [];
  private form: WPXFormValue<CreateShiftAutomationForm> = new WPXFormValue(CreateShiftAutomationForm);

  private async created(): Promise<void> {
    const users = await this.userRepository.getAllUsers();
    const shiftType = await this.shiftTypeRepository.getAllShiftTypes();
    this.users = users[0];
    this.shiftType = shiftType;
    this.loading = false;
  }

  private async createShiftType(): Promise<void> {
    try {
      await this.shiftAutomationRepository.createShiftAutomation({
        userId: this.form.data.userId,
        shiftType: this.form.data.shiftType,
      })

      this.$successDialog.show(`Shift Automation has been created.`);

      this.formReset();
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }

  private formReset(): void {
    this.form.data.userId = '';
    this.form.data.shiftType = 1;
  }
}
